import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, EMPTY, map, mergeMap, of } from 'rxjs';

import { DevicesService } from '@services/devices.service';
import {
  loadDeviceModels,
  loadDeviceModelsSuccess,
  loadDevices,
  loadDevicesFailure,
  loadDevicesSuccess,
} from '@store/actions/devices.actions';

@Injectable()
export class DeviceEffects {
  private readonly actions$ = inject(Actions);
  private readonly devicesService = inject(DevicesService);

  loadDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDevices),
      mergeMap(() =>
        this.devicesService.list().pipe(
          map((devices) => loadDevicesSuccess({ devices })),
          catchError((error) => of(loadDevicesFailure({ error }))),
        ),
      ),
    ),
  );

  loadDeviceModels$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDeviceModels),
      mergeMap(() =>
        this.devicesService.listModels().pipe(
          map((deviceModels) => loadDeviceModelsSuccess({ deviceModels })),
          catchError((error) => EMPTY),
        ),
      ),
    ),
  );
}
